import { ReferenceTableDescriptionSetEvent, } from '../event/reference-table-description-set.event';
const referenceTableDescriptionSetProjections = {
    [ReferenceTableDescriptionSetEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default referenceTableDescriptionSetProjections;
//# sourceMappingURL=reference-table-description-set.projection.js.map